import Shares from "./Shares";

export { Shares };
